<template>
  <div class="fab-stack">
    <button
      class="fab-btn"
      :class="{ 'fab-show': showTop }"
      title="回到顶部"
      aria-label="回到顶部"
      @click="toTop"
    >
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 19V5" />
        <path d="M5 12l7-7 7 7" />
      </svg>
    </button>
    <button
      class="fab-btn"
      :class="{ 'fab-show': showBottom }"
      title="去底部"
      aria-label="去底部"
      @click="toBottom"
    >
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 5v14" />
        <path d="M19 12l-7 7-7-7" />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  mounted() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
  data() {
    return {
      showTop: false,
      showBottom: false
    };
  },
  methods: {
    onScroll() {
      const top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      const viewH = window.innerHeight;
      const fullH = document.documentElement.scrollHeight;
      this.showTop = top > 300;
      // 页面够长且还没到底时才给去底部按钮
      this.showBottom = fullH - viewH - top > 300 && fullH > viewH * 2;
    },
    toTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    toBottom() {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style scoped>
.fab-stack {
  position: fixed;
  right: 26px;
  bottom: 34px;
  z-index: 4;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.fab-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid var(--border);
  background: var(--bg-card);
  color: var(--ink-mid);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(20, 20, 19, 0.08);
  opacity: 0;
  transform: translateY(8px);
  pointer-events: none;
  transition: opacity 0.25s ease, transform 0.25s ease, border-color 0.2s,
    color 0.2s, background 0.2s;
}
.fab-btn.fab-show {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}
.fab-btn:hover {
  border-color: var(--accent);
  color: var(--accent-deep);
  background: var(--accent-wash);
}
@media (max-width: 760px) {
  .fab-stack {
    right: 16px;
    bottom: 24px;
  }
  .fab-btn {
    width: 38px;
    height: 38px;
  }
}
</style>
